export default {
  meta: {
    title: '客户调研',
    url: '/abside/customerfollowup',
    urlName: 'ab侧-客户调研',
    logincallback: '/abside',
  }
};
